import cx from 'classnames';
import { FC, ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { ICatalogVacanciesReducerState } from '../../../redux/reducers/catalogVacanciesReducer';
import { RootState } from '../../../redux/reducers/rootReducer';
import { PaginationCatalog } from '../../PaginationCatalog';
import { VacanciesCard } from '../VacanciesCard';
import VacanciesCardHeader from '../VacanciesCardHeader';
import { getMainTag, getTagsList } from './functions';
import classes from './VacanciesCardsList.module.scss';
import { VacanciesCardsListProps } from './VacanciesCardsList.types';

export const VacanciesCardsList: FC<VacanciesCardsListProps> = ({
  className,
}): ReactElement => {
  const pagination = useSelector<
    RootState,
    ICatalogVacanciesReducerState['pagination'] | null
  >((state) => state.catalogVacanciesReducer.pagination);

  const cards = useSelector<
    RootState,
    ICatalogVacanciesReducerState['vacancies'] | null
  >((state) => state.catalogVacanciesReducer.vacancies);

  const [searchParams, setSearchParams] = useSearchParams();

  const changePage = (page: number | string) => {
    const params = searchParams;
    params.set('page', page.toString());

    setSearchParams(params);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [searchParams.get('page')]);

  if (pagination?.data.totalCount === 0) {
    return (
      <div>
        <VacanciesCardHeader />
        <div className={cx(classes['vacancies-cards-list__empty'])}>
          <p className={classes['vacancies-cards-list__empty-text']}>
            По вашему запросу ничего не найдено
          </p>
          <p className={classes['vacancies-cards-list__empty-description']}>
            {'Попробуйте ввести другое название\nили изменить параметры поиска'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={cx(classes['vacancies-cards-list'], className)}>
      <VacanciesCardHeader />

      <div className={classes['vacancies-cards-list__body']}>
        {cards?.data
          ? cards?.data.map((item) => (
            <VacanciesCard
              idForUrl={item.idForUrl}
              key={item.id}
              className={classes['vacancies-cards-list__vacancies-card']}
              title={item.title}
              tag={getMainTag(item.division)}
              tagsList={getTagsList(item)}
              workFormatList={item.wf}
            />
          ))
          : null}
      </div>

      <PaginationCatalog
        className={classes['vacancies-cards-list__pagination-catalog']}
        currentPage={Number(searchParams.getAll('page')?.[0]) || 1}
        totalPages={pagination?.data.pages || 1}
        setPageNumber={changePage}
      />
    </div>
  );
};
